<template lang="pug">
  div.page--thank-you.page
    checkout-page-header.page-header--account(
      :step="3"
      header-class="page-header--checkout-step"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container.mt-lg-5.mt-3(v-if="order")
      .row.mb-2.mb-lg-4
        .col.text-center
          .text-success.page-thank-you__icon
            font-awesome-icon(:icon=['far', 'check-circle'])
          h2.page-thank-you__title {{ trans('labels.frontend.thank-you.thank_you_headline') }}
          p.page-thank-you__subtitle(v-if="order.status === 'pending_order'")
            | {{ trans('labels.frontend.thank-you.due_date') }}
            | {{ moment(order.due_date).format('D MMMM YYYY') }}
            | {{ trans('labels.general.time') }}
            | {{ moment(order.due_date).format('HH:mm') }}
      .row.justify-content-center
        .col-xl-8.col-lg-10.col-md-12
          .order-summary
            .order-summary__content
              h3.order__summary_label {{ trans('labels.frontend.thank-you.order_no') }}
              span.order_summary_value {{ order.number }}
            .order-summary__content
              h3.order__summary_label {{ trans('labels.frontend.thank-you.date') }}
              span.order_summary_value {{ order.created_at | moment('D/M/Y HH:mm') }}
            .order-summary__content
              h3.order__summary_label {{ trans('labels.frontend.thank-you.total') }}
              span.order_summary_value ฿ {{ order.net_total | numeral }}
            .order-summary__content
              h3.order__summary_label {{ trans('labels.frontend.thank-you.status') }}
              span.order_summary_value {{ order.status_label }}
          .bank-information.mb-5(v-if="order.status === 'pending_order'")
            h3.bank-information__title {{ trans('labels.frontend.thank-you.bank_accounts') }}
            p.bank-information__subtitle {{ trans('labels.frontend.thank-you.bank_following') }}
            ul#tabs.nav.nav-tabs.nav-tabs--icons(role='tablist')
              li.nav-item(v-for="(bank, index) in setting.bank_information" v-if="setting.bank_information")
                a.nav-link(
                  :id="'tab-' + index" :href="'#pane-' + index"
                  data-toggle='tab', role='tab', :aria-controls="'pane-' + index", aria-selected='true'
                  v-bind:class="{'active': index === 0}"
                )
                  img.nav-icon(:src="'/img/frontend/logo/payment/' + bank.bank_name + '.png'", alt='')
                  | {{ getBankName(bank.bank_name) }}
            #content.tab-content(role='tablist')
                .card.tab-pane.fade(
                  :id="'pane-' + index" :aria-controls="'pane-' + index"
                  v-for="(bank, index) in setting.bank_information" v-if="setting.bank_information"
                  role='tabpanel' v-bind:class="{'show': index === 0, 'active': index === 0}"
                )
                  .card-header(
                    :id='"heading-" + index'
                    role='tab'
                    data-toggle='collapse'
                    :href='"#collapse-" + index'
                    data-parent='#content'
                    aria-expanded='false'
                    :aria-controls='"collapse-" + index'
                  )
                    .card-header__toggle
                      font-awesome-icon(:icon=['far', 'angle-down'])
                    img.nav-icon(:src="'/img/frontend/logo/payment/' + bank.bank_name + '.png'", alt='')
                    | {{ getBankName(bank.bank_name) }}
                  .collapse(role='tabpanel', :aria-labelledby='"heading-" + index' :id='"collapse-" + index')
                    .card-body
                      .row
                        .col-md-8
                          table.table.table-borderless.table-sm
                            tbody
                              tr
                                td {{ trans('labels.frontend.thank-you.bank') }}
                                td
                                  strong {{ getBankName(bank.bank_name) }}
                              tr
                                td {{ trans('labels.frontend.thank-you.account_name') }}
                                td
                                  span(v-if="!$store.getters['auth/user'].locale || $store.getters['auth/user'].locale === 'th'") {{ bank.account_name }}
                                  span(v-if="$store.getters['auth/user'].locale && $store.getters['auth/user'].locale === 'en'") {{ bank.account_name_en }}
                          p.mb-0 {{ trans('labels.frontend.thank-you.account_no') }}
                          p.mb-lg-5.mb-4
                            span.bank-information__account-no {{ bank.account_no }}
                          router-link.btn.btn-primary.btn-sm(:to="{ name: 'account.payment-notify' }") {{ trans('labels.frontend.payment-confirmation.payment-confirmation-title') }}
                        .col-md-4.d-none.d-md-flex
                          div.bank-information__qr-container
                            img.img-fluid.bank-information__qr-code(:src="bank.account_qr_url", alt='' v-if="bank.account_qr_url")
          .order-details
            h3.order-details__title {{ trans('labels.frontend.thank-you.order_summary') }}
            order-summary-table(:order="order")
            order-shipping-billing-details(v-if="order" :order="order")
    .payment-confirmation(v-if="order.status === 'pending_order'")
      .container
        .row.justify-content-center
          .col-xl-8.col-lg-10.col-md-12
            h4.payment-confirmation__title {{ trans('labels.frontend.payment-confirmation.payment-confirmation-title') }}
            payment-confirmation-box


</template>

<script>
import PaymentConfirmationBox from '../../../components/payment/PaymentConfirmationBox.vue';
import OrderShippingBillingDetails from '../../../components/order/OrderShippingBillingDetails.vue';
import OrderSummaryTable from '../../../components/order/OrderSummaryTable.vue';
import CheckoutPageHeader from '../../../components/layouts/CheckoutPageHeader.vue';
import { RepositoryFactory } from '../../../repositoryFactory';
import ConversionManager from '../../../mixins/ConversionManager';

const OrderRepository = RepositoryFactory.get('order');
const SettingRepository = RepositoryFactory.get('setting');

export default {
  components: {
    OrderShippingBillingDetails,
    OrderSummaryTable,
    CheckoutPageHeader,
    PaymentConfirmationBox,
  },
  mixins: [ConversionManager],
  data() {
    return {
      order: {},
      setting: {},
    };
  },
  computed: {
    moment() {
      return window.moment;
    },
  },
  metaInfo() {
    return {
      title: Lang.get('labels.frontend.cart.steps.completed'),
    };
  },
  mounted() {
    this.$store.dispatch('cart/empty');
    this.getCart();
    this.getSettings();
    this.getOrder();

    this.$ga.ecommerce.setAction('checkout', {
      step: 4,
    });
  },
  methods: {
    async getCart() {
      try {
        const { data } = await this.$store.dispatch('cart/get', { id: this.$store.getters['cart/id'] });
        this.cart = data;
      } catch (e) {
        this.cart = {};
      }
    },
    getBankName(bank) {
      let name = '';
      switch (bank) {
        case 'kbank':
          name = Lang.get('labels.frontend.payment-confirmation.banks.kbank');
          break;
        case 'bbl':
          name = Lang.get('labels.frontend.payment-confirmation.banks.bbl');
          break;
        case 'scb':
          name = Lang.get('labels.frontend.payment-confirmation.banks.scb');
          break;
        case 'ktb':
          name = 'กรุงไทย';
          break;
        default:
          break;
      }
      return name;
    },
    async getSettings() {
      const { data } = await SettingRepository.get({ name: 'bank_information' });
      this.setting = data;
    },
    async getOrder() {
      const { data } = await OrderRepository.getById(this.$route.query.order).then((resp) => resp.data);
      this.order = data;
      this.trackEvent('Conversion', 'Purchase', 'Order Placed', 'Thank You Page', this.order.net_total, { transaction_id: this.order.number });
      if (process.env.NODE_ENV === 'production') {
        this.$ga.ecommerce.addTransaction({
          id: this.order.number,
          revenue: parseFloat(this.order.net_total),
          tax: 0,
          shipping: parseFloat(this.order.shipping_total),
        });
      }
    },
  },
};
</script>
